import request from '@/utils/request'

/**
 * 工作台API接口
 */

/**
 * 获取工作台总览数据（KPI + 图表）
 */
export function getDashboardOverview() {
  return request({
    url: '/dashboard/overview',
    method: 'get'
  })
}

/**
 * 获取待办事项汇总
 * @param {Object} params - { category, page, size }
 */
export function getTodoSummary(params) {
  return request({
    url: '/dashboard/todos',
    method: 'get',
    params
  })
}

/**
 * 手动刷新工作台数据
 */
export function refreshDashboard() {
  return request({
    url: '/dashboard/refresh',
    method: 'post'
  })
}
